<template>
    <div>


      <SearchForm
        placeholder="Поиск:"
        danger="true"
        smallText="Введите наименование, децимальный или серийный номер изделия <br> *Например: <span>БВИ-М</span>, <span>ЦАКТ.402223.005</span> или <span>9841</span>"
        urlS="https://elmeh.ru:10110/s=="
        urlN="https://elmeh.ru:10110/n=="
      />
      
      <!--
        <div class="row">
        <div class="column">


          <ul v-if="list_serial === ''">
              <li>
                <Error />
              </li>
            </ul>

          <ul class="serial__items">
              <li v-for="item in list_serial" :key="item.id" class="serial__item">
                <div class="docs">
                  <div class="docs__fullname">{{ item.name }}</div>
                  <div class="docs__cakt">{{ item.cakt }}</div>
                  <serial-result :docs='item.cakt'></serial-result>
                </div>
              </li>
            </ul>

          
        </div>
      </div>
      -->
    </div>
</template>

<script>
import axios from 'axios'
import SearchForm from '@/components/forms/SearchForm2.vue'
//import SerialResult from '@/components/serial-result.vue'
//import MainFinder from '@/components/MainFinder.vue'
//import Error from '@/components/Errors/Error.vue'

export default {
  name: 'SerialDocs',
  components: {
    SearchForm,
    //SerialResult,
    //MainFinder,
    //Error
  },
  data() {
    return {
      list_serial: null,
      user_serial: null
    }
  },
  methods: {
    searchSerial() {
			var vm = this;
			axios.get('https://elmeh.ru:10110/' + 'n=="' + this.user_serial + '"',
      {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }) 
      .then(function(response) {
				vm.list_serial = response.data;
			}, function(error) {
				console.log(error.statusText);
      });
    }
  }
} 
</script>

<style lang="sass">
.docs-search-form
  display: flex
  max-width: 400px
  width: 100%
.serial
  &__item
    width: 70%
    &:last-child
      border-bottom: 0
  &__name
    font-size: 16px
    margin: 0
  &__cakt
    margin: 0
    margin-top: 5px
    font-size: 14px

.serial__items .serial__item .serial-subitems_error
  display: none
.serial__items .serial__item:first-child .serial-subitems_error
  display: block
</style>